import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NamedField } from '@shared/interfaces/field.interface';
import { FormArray, FormGroup } from '@angular/forms';
import { FieldBase } from './field-base';

@Component({
  selector: 'app-date-field',
  template: `
    <ng-container [formGroup]="group">
      <mat-label class="field__label" *ngIf="field.label"
        >{{ field.label | translate }}
        <span *ngIf="isRequired" class="text-warn">*</span></mat-label
      >
      <div>
        <div *ngIf="field.prefix" matPrefix (click)="prefixClick.emit($event)">
          <ng-container #prefixRef></ng-container>
        </div>
        <app-date-input
          class="field__input"
          #element
          [id]="field.name + '_' + uuid"
          [formControl]="group.get(field.name)"
          [title]="title"
          [min]="min"
          [max]="max"
          [disabled]="disabled"
          [enableEditing]="enableEditing"
          [enableTime]="enableTime"
          [selectMonthAndYear]="selectMonthAndYear"
          [selectYear]="selectYear"
          [startView]="startView"
          [placeHolder]="placeHolder"
          (click)="fieldClick.emit($event)"
        >
        </app-date-input>
        <div *ngIf="field.suffix" matSuffix (click)="suffixClick.emit($event)">
          <ng-container #suffixRef></ng-container>
        </div>
        <mat-error *ngIf="errors.length && group.get(field.name)?.touched" class="field__error">
          <app-field-errors [errors]="errors"></app-field-errors>
        </mat-error>
      </div>
    </ng-container>
  `,
  host: { class: 'field' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFieldComponent extends FieldBase {
  @Input() field: NamedField;
  @Input() group: FormGroup | FormArray;
  @ViewChild('element') element: ElementRef;
  @Input() rootForm: FormGroup | FormArray;

  @Input() title: string;
  @Input() min = null;
  @Input() max = null;
  @Input() disabled = false;
  @Input() enableEditing = false;
  @Input() enableTime = false;
  @Input() selectMonthAndYear = false;
  @Input() selectYear = false;
  @Input() startView = 'month';
  @Input() placeHolder = 'Placeholder.DatePlaceholder';
}
